import { useState } from "react";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import { Outlet, useLocation } from "react-router-dom";
import { useViewMode } from "@/contexts/ViewModeContext";

const TITLES = {
  "/": { t: "Dashboard Executivo", s: "Visão geral do grupo" },
  "/empresas": { t: "Empresas", s: "Grupo Econômico" },
  "/setores": { t: "Setores & Quadro", s: "Ocupação por setor" },
  "/colaboradores": { t: "Colaboradores", s: "Quadro de pessoal" },
  "/cargos-salarios": { t: "Cargos e Salários", s: "Plano e tabela salarial" },
  "/organograma": { t: "Organograma", s: "Estrutura organizacional" },
  "/escalas": { t: "Escalas & Jornadas", s: "Horários de trabalho" },
  "/recrutamento": { t: "Recrutamento & Seleção", s: "Vagas e candidatos" },
  "/treinamentos": { t: "Treinamentos", s: "Liderança e desenvolvimento" },
  "/desligamentos": { t: "Desligamentos", s: "Demissão e pedido de demissão" },
  "/auditoria": { t: "Auditoria", s: "Trilha de eventos" },
  "/admin/usuarios": { t: "Usuários & Perfis", s: "Controle de acesso" },
  "/importacao": { t: "Importação de Colaboradores", s: "Excel / CSV" },
  "/relatorios-ia": { t: "Central Inteligente de Relatórios", s: "Geração por linguagem natural" },
  "/gestao": { t: "Gestão do RH", s: "Hub administrativo" },
};

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();
  const info = TITLES[loc.pathname] || { t: "TheoKratos RH", s: "" };
  const { effective } = useViewMode();

  // When user picks Mobile or Tablet explicitly, we always hide the fixed sidebar
  // and rely on the drawer ("hamburger"). Desktop -> fixed sidebar.
  const showFixedSidebar = effective === "desktop";

  return (
    <div
      data-viewmode-layout={effective}
      className="flex h-screen overflow-hidden bg-background"
    >
      {/* Fixed Sidebar (only in desktop effective mode) */}
      {showFixedSidebar && (
        <div className="h-full shrink-0">
          <Sidebar />
        </div>
      )}

      {/* Drawer (used by tablet/mobile or when user opens it on desktop) */}
      {mobileOpen && (
        <div className="fixed inset-0 z-30 flex">
          <div className="h-full"><Sidebar onNavigate={() => setMobileOpen(false)} /></div>
          <div className="flex-1 bg-black/40" onClick={() => setMobileOpen(false)} />
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar
          onToggleSidebar={() => setMobileOpen(true)}
          title={info.t}
          subtitle={info.s}
          showHamburger={!showFixedSidebar}
        />
        <main className="flex-1 overflow-y-auto rh-main animate-fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
